import store from '@/store';
import { feishu } from '@/util/config';
import * as u from '@/util/util';
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';

const service = axios.create({
  // baseURL: c.system.apiUrl,
  baseURL: '/api', // api 的 base_url  use proxy table
  // baseURL: "http://172.23.10.162:8080",
  // timeout: 5000, // request timeout
  timeout: 10000, // 请求超时10秒
  paramsSerializer: function (params) {
    // 自定义参数序列化，roleNames用逗号分隔，其他数组保持默认格式
    const searchParams = new URLSearchParams();
    for (const key in params) {
      if (params[key] !== null && params[key] !== undefined) {
        if (Array.isArray(params[key])) {
          // 只对特定字段使用逗号分隔，其他数组字段保持默认行为
          if (key === 'roleNames') {
            searchParams.append(key, params[key].join(','));
          } else {
            // 其他数组字段使用默认的 [] 格式
            params[key].forEach(value => {
              searchParams.append(key + '[]', value);
            });
          }
        } else {
          searchParams.append(key, params[key]);
        }
      }
    }
    return searchParams.toString();
  }
});

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (u.getToken()) {
      // 让每个请求携带token-- ['X_ACCESS_TOKEN']为自定义key 请根据实际情况自行修改
      config.headers['X-Access-Token'] = u.getToken();
    }

    store.commit('setLoading', true);
    return config;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  async response => {
    const res = response.data ?? response;
    store.commit('setLoading', false);
    //判断是否为文件类型响应
    const contentType = response.headers['content-type'];
    if (
      contentType &&
      (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
        contentType.includes('application/octet-stream') ||
        contentType.includes('application/vnd.ms-excel'))
    ) {
      return response; // 如果是文件，直接返回完整的 response
    }
    if (res.code == 200 || res.code == 1) {
      return response.data;
    } else if (res.code === 401) {
      MessageBox.alert('登录已失效，请重新登录？', '提示', {
        confirmButtonText: '确认',
        type: 'warning'
      })
        .then(() => {
          //清楚token里面的信息
          u.clearSession();
          window.location.href = feishu.getAuthUrl();
        })
        .catch(() => {
          u.clearSession();
        });
      return Promise.reject();
    } else {
      if (!res) {
        Message({
          message: '调用接口失败',
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject();
      }
      if (res.msg) {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        });
        return response.data;
      }
      const blobText = await res.text();
      const { msg } = JSON.parse(blobText);
      Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000
      });
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    store.commit('setLoading', false);
    return Promise.reject(error);
  }
);

export default service;
